export default __webpack_public_path__ + "static/media/0.669bd6c7.png";